import { FamilyLinkageInvitation } from 'pages/Profile/FamilyLinkage/components/FamilyLinkageInvitation';
import { List, Section, Title } from 'pages/Profile/FamilyLinkage/styles';

export function CancelledInvitations({ invitations }) {
  return (
    <Section>
      <Title>Cancelled invitations</Title>

      <List>
        {invitations.map((fi) => (
          <FamilyLinkageInvitation
            firstName={fi.invitee_first_name}
            lastName={fi.invitee_last_name}
          />
        ))}
      </List>
    </Section>
  );
}
